import { AlsActivityStatus, CprActivityStatus } from '../../../graphql/generated';

export const getStatusLabel = (statusValue: string) => {
  switch (statusValue) {
    case AlsActivityStatus?.AlsReSubmitted:
    case AlsActivityStatus?.AlsSubmitted:
    case CprActivityStatus?.CprSubmitted:
    case CprActivityStatus?.CprReSubmitted:
      return 'Awaiting Approval';
    case AlsActivityStatus?.AlsDraft:
    case CprActivityStatus?.CprDraft:
      return 'Draft';
    case AlsActivityStatus?.AlsReturned:
    case CprActivityStatus?.CprReturned:
      return 'Returned';
    case AlsActivityStatus?.AlsCancelled:
    case CprActivityStatus?.CprCancelled:
      return 'Cancelled';
    default:
      return undefined;
  }
};
